import Component from '../Component';
import RootNode from './RootNode';
import Node from './Node';
import Line from './Line';
import Raphael from 'raphael';
import { addClass, hasClass, removeClass } from '../../support/classes';
import { createElement } from '../../support/dom';

class MindMap extends Component
{
    constructor(element, props)
    {
        super(element, props);

        this.props.nodes = JSON.parse(atob(this.props.nodes));

        this.initialize();
    }

    getDefaultProps()
    {
        return {
            canvasError: 'alert',
        };
    }

    initialize()
    {
        addClass(this.element, 'mind-map');

        this.activeNode = null;
        this.canvas = null;
        this.lines = [];

        this.initCanvas();

        this.initNodes();

        this.bindEvents();
    }

    initCanvas()
    {
        const { offsetWidth, offsetHeight } = this.element;

        this.canvas = Raphael(this.element, offsetWidth, offsetHeight);
    }

    initNodes()
    {
        if (!this.props.nodes.length)
        {
            return;
        }

        const { text, link, nodes } = this.props.nodes[0];

        this.nodes = new Node(text, link, nodes);

        this.nodes.forEach((node) => {
            this.addLine(node.parent, node);
        })

        this.renderNodes();

        this.setActiveNode(this.nodes);
    }

    renderNodes()
    {
        this.nodes.appendTo(this.element);
    }

    renderLines(instant)
    {
        this.canvas.clear();

        this.activeNode.children.forEach((node) => {
            this.addLine(node.parent, node, instant);
        });
    }

    addLine(startNode, endNode, instant)
    {
        const line = this.lines[this.lines.length] = new Line(startNode, endNode);

        const path = this.canvas
            .path(line.getPath())
            .attr(line.getAttributes());

        if (instant)
        {
            path.attr({ opacity: 0.2 });
        }
        else
        {
            setTimeout(() => {
                path.attr({ opacity: 0.2 });
            }, 250);
        }
    }

    setActiveNode(node)
    {
        if (node.hasChildren())
        {
            this.activeNode && this.activeNode.setActive(false);
        
            node.setActive(true);
            node.setPosition(this.element.offsetWidth / 2, this.element.offsetHeight / 2);

            this.activeNode = node;

            this.renderLines();
        }
        else
        {
            const link = node.getLink();

            if (link !== '')
            {
                window.location = link;
            }
        }
    }

    _handleResize = (e) =>
    {
        const { offsetWidth, offsetHeight } = this.element;

        this.canvas.setSize(offsetWidth, offsetHeight);

        this.activeNode.setPosition(offsetWidth / 2, offsetHeight / 2);

        this.renderLines(true);
    }

    _handleClick = (e) =>
    {
        // findNode
        let target = e.target;
        while (!hasClass(target, 'node'))
        {
            target = target.parentNode;
        }

        const node = this.nodes.findByElement(target);

        // Nothing found.
        if (!node)
        {
            return;
        }

        // If already active and clicked, set the active one
        // to the parent node.
        if (node.isActive())
        {
            node.parent && this.setActiveNode(node.parent);
        }
        else
        {
            this.setActiveNode(node);
        }

        e.preventDefault();
    }

    bindEvents()
    {
        this.element.addEventListener('click', this._handleClick, false);
        window.addEventListener('resize', this._handleResize);
    }

    unbindEvents()
    {
        this.element.removeEventListener('click', this._handleClick);
        window.removeEventListener('resize', this._handleResize);
    }
}

export default MindMap;